"use client";
import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";
import ProductImg from "./ProductImg";
import { ITheme } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useProductBox } from "../../context/ProductBoxContext";
import SvgBarLove from "@/app/layouts/mobile-layout/mobile-navigator/navigator-icons/SvgBarLove";
import { useWishlist } from "@/hooks/useWishlist";
import SvgFilledLove from "@/app/layouts/mobile-layout/mobile-navigator/navigator-icons/SvgFilledLove";
import { getVisibleProductTags } from "@/utils/functions/product-tags";
import { useMemo } from "react";

interface Props {
  scrollableTabs: boolean;
  size: Size;
  priority: boolean;
  theme: ITheme | undefined;
  /** `product.tag_ids` — resolved here against the theme config into badge data. */
  tagIds: number[] | null | undefined;
  productId: number;
}

const ProductBoxImage: React.FC<Props> = ({
  size,
  priority,
  scrollableTabs,
  theme,
  tagIds,
  productId,
}) => {
  const { selectedChild, outOfStock } = useProductBox();
  const productTags = useMemo(
    () => getVisibleProductTags(tagIds, theme?.components?.product?.product_tags),
    [tagIds, theme?.components?.product?.product_tags],
  );
  const { isFavorite, toggle } = useWishlist(
    selectedChild?.id,
    selectedChild.is_favorite,
  );

  return (
    <ProductImg
      discount={selectedChild.discount}
      className={`${
        scrollableTabs
          ? "product-box-image-scrollable-tabs"
          : "product-image-container"
      } `}
      src={
        (selectedChild as any)?.thumbnail_url ??
        (selectedChild as any)?.image_url ??
        selectedChild?.images?.[0]?.thumbnail_url ??
        selectedChild?.images?.[0]?.image_url
      }
      size={size}
      is_new={selectedChild.is_new}
      has_discount={
        selectedChild.has_discount || selectedChild.discount_amount > 0
      }
      discount_type={selectedChild.discount_type}
      discount_amount={selectedChild.discount_amount}
      priority={priority}
      theme={theme}
      images={(selectedChild?.images ?? []) as IProduct["images"]}
      outOfStock={outOfStock}
      sold_quantity={selectedChild.sold_quantity}
      productTags={productTags}
      productId={productId}
      overlay={
        <div
          onMouseDown={(e) => e.preventDefault()}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            toggle();
          }}
          className={`product-box-image-favorite-button ${
            isFavorite ? "selected" : "unselected"
          }`}
        >
          {isFavorite ? (
            <SvgFilledLove size={18} />
          ) : (
            <SvgBarLove
              selected={isFavorite}
              customSelectedColor="white"
              customUnselectedColor="secondary"
              size={18}
            />
          )}
        </div>
      }
    />
  );
};

export default ProductBoxImage;
